module.exports = __webpack_public_path__ + "img/sec11mob.d583db0a.png";